import {
  featureComponents
} from "#blokkli-build/features";
import { computed, ref } from "#imports";
import { falsy } from "./index.js";
export default function(storage) {
  const mountedFeatures = ref([]);
  const settingsSettings = storage.use(
    "feature:settings:settings",
    {}
  );
  const enabledBetaFeatures = computed(() => {
    return Object.entries(settingsSettings.value).map(([key, value]) => {
      const [a, b] = key.split(":");
      if (a === "beta" && b && value === true) {
        return b;
      }
      return null;
    }).filter(falsy);
  });
  const features = computed(() => mountedFeatures.value);
  const betaFeatures = computed(
    () => featureComponents.filter((v) => v.beta).map((v) => {
      return {
        id: v.id,
        label: v.label,
        description: v.description
      };
    })
  );
  const unmount = (id) => {
    mountedFeatures.value = mountedFeatures.value.filter((v) => v.id !== id);
  };
  const mount = (feature) => {
    mountedFeatures.value.push(feature);
  };
  return {
    features,
    betaFeatures,
    enabledBetaFeatures,
    mount,
    unmount
  };
}
